const http = require('../lib/httpClient');
const { getChannelId, getCookie, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { decodeJWT } = require('../utils/decoder');
const { COOKIES, COMMERCE_HEADER } = require('../constants');

const impersonationLoginError = {
  code: 'INVALID_AGENT_SESSION_ERROR',
  message: 'Invalid Agent Session',
};

const loginEndpoint = '/s/auth/v1/impersonation/login';

async function impersonationLogin(emailAddress, tenantId, agentBaseUrl = '', additionalInfo = {}) {
  const agentSessionId = getCookie(COOKIES.AGENT_SESSION.VALUE);
  const result = await http.post(
    `${agentBaseUrl}${loginEndpoint}`,
    {
      emailAddress,
    },
    {
      headers: {
        Authorization: agentSessionId,
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId, additionalInfo),
        'x-commerce': getXCommerceValue(agentBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [impersonationLoginError] };
  const { idToken: sessionJWT, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  const sessionData = decodeJWT(sessionJWT);
  return { data: { ...responseBody, ...sessionData }, errors: [] };
}

module.exports = impersonationLogin;
